import { BodyText, ParagraphTitle } from 'modules/ui';
import { Accordion } from 'modules/ui/accordion';
import {
  CommonJob,
  TransportAndUtilityPrivateTransport,
} from 'modules/ui/icons';
import { InfoCard } from 'modules/ui/infoCard';
import { InfoCardType } from 'modules/ui/infoCard/components/InfoCardType';
import { Trans, useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { ContactPathsEnum } from 'modules/contactPage/routes';
import { InfoContainer } from './styled';

export const LeasingTypeInfo: React.FC = () => {
  const { t } = useTranslation();

  return (
    <InfoContainer>
      <ParagraphTitle>
        {t('leasingCalculator.infoCalculation.leasingTypeInfo.title')}
      </ParagraphTitle>

      <Accordion
        icon={<TransportAndUtilityPrivateTransport />}
        title={t(
          'leasingCalculator.infoCalculation.leasingTypeInfo.operationalLeasingTitle',
        )}
        onOpen={() => {}}>
        <BodyText>
          {t(
            'leasingCalculator.infoCalculation.leasingTypeInfo.operationalLeasingDescription',
          )}
        </BodyText>
      </Accordion>
      <Accordion
        icon={<CommonJob />}
        title={t(
          'leasingCalculator.infoCalculation.leasingTypeInfo.financialLeasingTitle',
        )}
        onOpen={() => {}}>
        <BodyText>
          {t(
            'leasingCalculator.infoCalculation.leasingTypeInfo.financialLeasingDescription',
          )}
        </BodyText>
      </Accordion>
      <InfoCard
        title={t(
          'leasingCalculator.infoCalculation.leasingTypeInfo.infoCardTitle',
        )}
        description={
          <Trans
            i18nKey="leasingCalculator.infoCalculation.leasingTypeInfo.infoCardDescription"
            components={{
              contactLink: <Link style={{color: "#007A91"}} to={ContactPathsEnum.contactPage} />,
            }}
          />
        }
        type={InfoCardType.CardWidePlain}
      />
    </InfoContainer>
  );
};
